import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  LOCALE_ID,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';

import Moment = moment.Moment;

@Component({
  selector: 'app-year-datepicker',
  templateUrl: 'year-datepicker.component.html',
  styleUrls: ['year-datepicker.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [LOCALE_ID, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'YYYY',
        },
        display: {
          dateInput: 'YYYY',
          monthYearLabel: 'YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'YYYY',
        },
      },
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YearDatepickerComponent implements OnInit {
  private _maxDate: string = moment().toISOString();
  get maxDate(): string {
    return this._maxDate;
  }
  @Input() set maxDate(value: string) {
    if (value) {
      this._maxDate = value;
    } else {
      this._maxDate = undefined;
    }
  }

  private _minDate: string;
  get minDate(): string {
    return this._minDate;
  }
  @Input() set minDate(value: string) {
    if (value) {
      this._minDate = value;
    }
  }
  @Input() navigationArrows = true;

  datepickerDate = new FormControl<moment.Moment>(moment());

  @Output() dateChanged = new EventEmitter<Moment>();

  ngOnInit(): void {
    this.resetDate();
  }

  resetDate(): void {
    this.datepickerDate = new FormControl<moment.Moment>(moment());
  }

  onSelectYear(normalizedYear: Moment, datepicker: MatDatepicker<any>): void {
    const yearValue = this.datepickerDate.value.year(normalizedYear.year());
    this.datepickerDate.setValue(yearValue);

    datepicker.close();

    this.dateChanged.emit(this.datepickerDate.value);
  }

  canSelectNextYear(): boolean {
    if (this.maxDate) {
      const nextYearDate = moment(this.datepickerDate.value).startOf('year').add(1, 'y');
      const isAfterMaxDate = moment(nextYearDate).isAfter(moment(this.maxDate).startOf('year'));

      return !isAfterMaxDate;
    } else {
      return true;
    }
  }

  canSelectPreviousYear(): boolean {
    if (this.minDate) {
      const previousYearDate = moment(this.datepickerDate.value).startOf('year').subtract(1, 'y');
      const isBeforeMinDate = moment(previousYearDate).isBefore(
        moment(this.minDate).startOf('year')
      );

      return !isBeforeMinDate;
    } else {
      return true;
    }
  }

  onNextYear(): void {
    if (this.canSelectNextYear()) {
      const nextYearDate = moment(this.datepickerDate.value).add(1, 'y');
      this.datepickerDate.setValue(nextYearDate);
      this.dateChanged.emit(this.datepickerDate.value);
    }
  }

  onPreviousYear(): void {
    if (this.canSelectPreviousYear()) {
      const previousYearDate = moment(this.datepickerDate.value).subtract(1, 'y');
      this.datepickerDate.setValue(previousYearDate);
      this.dateChanged.emit(this.datepickerDate.value);
    }
  }
}
